import {createContext} from 'react';

export default createContext('__uninitialized__');
